<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4 class="text-bold">Fabric Roll Logs</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-4">
            <v-select
              :options="allFabrics"
              v-model="selectedFabricId"
              label="production_name"
              @input="getRollLogs"
              :reduce="(allFabrics) => allFabrics.id"
              placeholder="Choose One"
            />
          </div>
          <div class="col-md-3">
            <input
              type="text"
              class="form-control"
              v-model="shirtOrderNumberFilter"
              placeholder="Order Number"
              @change="applyShirtOrderNumberFilter"
            />
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-primary"
              @click="applyShirtOrderNumberFilter()"
            >
              Apply filter
            </button>
            <button
              class="btn btn-secondary text-right"
              @click="clearRollLogFilters()"
            >
              Cancel
            </button>
          </div>
          <div class="col-md-3 text-right">
            <button
              class="btn btn-primary"
              @click="addRollsManually()"
              v-if="showAddRollButton"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i>
              Add Rolls Manually
            </button>
          </div>
        </div>
        <br />

        <log-view
          title="IN USE"
          :rolls="filteredLogs.in_use"
          color="primary"
          :filter="shirtOrderNumberFilter"
          :isReadOnlyUser="isReadOnlyUser"
        />
        <log-view
          title="WAREHOUSE"
          :rolls="filteredLogs.warehouse"
          color="success"
          :deleteBtn="true"
          :filter="shirtOrderNumberFilter"
          :isReadOnlyUser="isReadOnlyUser"
        />
        <log-view
          title="EMPTY"
          :rolls="filteredLogs.empty"
          color="warning"
          :deleteBtn="true"
          :filter="shirtOrderNumberFilter"
          :isReadOnlyUser="isReadOnlyUser"
        />
        <log-view
          title="DELETED"
          :rolls="filteredLogs.deleted"
          color="danger"
          :filter="shirtOrderNumberFilter"
          :isReadOnlyUser="isReadOnlyUser"
        />
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="add-roll"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white text-bold">Add Roll Manually</h5>
          </div>
          <div class="modal-body bg-white">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th width="50">
                    <button class="btn btn-primary" @click="addNewRoll">
                      <i class="fa fa-plus-circle" aria-hidden="true"></i>
                    </button>
                  </th>
                  <th width="300">Select Fabric</th>
                  <th width="150">Length</th>
                  <th width="100">Unit</th>
                  <th width="300">Supplier</th>
                  <th width="50"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(roll, index) in newRolls" :key="index">
                  <td>{{ index + 1 }}.</td>
                  <td>
                    <v-select
                      :options="allFabrics"
                      v-model="roll.fabric_id"
                      label="production_name"
                      @change="getCurrentSupplier(index)"
                      :reduce="(allFabrics) => allFabrics.id"
                      placeholder="Choose One"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="Length"
                      v-model="roll.length"
                      class="form-control text-right"
                    />
                  </td>
                  <td>
                    <select class="form-control" v-model="roll.unit">
                      <option value="m">Meter</option>
                      <option value="y">Yard</option>
                      <option value="kg">Kilogram</option>
                    </select>
                  </td>
                  <td>
                    <v-select
                      class="bg-white br-5"
                      :options="suppliers"
                      v-model="roll.supplier_id"
                      label="full_name"
                      :reduce="(supplier) => supplier.id"
                      placeholder="Choose One"
                    />
                  </td>
                  <td class="text-right">
                    <button
                      class="btn btn-danger"
                      @click="newRolls.splice(index, 1)"
                    >
                      <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              CANCEL
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="createNewRolls"
            >
              ADD ROLLS
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogView from "./components/RollLog";
export default {
  components: {
    LogView,
  },
  data() {
    return {
      isReadOnlyUser: false,
      allFabrics: [],
      suppliers: [],
      selectedFabricId: null,
      originalLogs: { in_use: [], empty: [], warehouse: [] },
      filteredLogs: { in_use: [], empty: [], warehouse: [] },
      newRolls: [],
      showAddRollButton: false,
      shirtOrderNumberFilter: "",
    };
  },
  created() {
    this.selectedFabricId = this.$route.params.fabric_id;
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getFabrics();
    this.getSuppliers();
    this.getRollLogs();
    this.addNewRoll();
    this.showAddRollButton = this.$auth.user().role === "admin";
  },
  methods: {
    addRollsManually() {
      show_modal("#add-roll");
    },

    addNewRoll() {
      this.newRolls.push({
        fabric_id: null,
        length: 0,
        unit: "m",
        supplier_id: null,
        supplier_code: null,
      });
    },

    async createNewRolls() {
      let temp = this.newRolls.filter((f) => {
        return f.fabric_id === null || f.length === 0;
      });

      if (temp.length > 0) {
        Swal.fire(
          "ERROR",
          "Fabric id should Not be empty and <br> Length Should Not Be Zero",
          "error"
        );
        return false;
      }
      if (await ezy.confirm("Are You Sure?")) {
        /*
         * Id = 0 (fabricId) because this route can create rolls for different fabrics at the same time.
         * Fabrics Ids will be sent in request body
         */
        try {
          let res = await axios.post("/v2/fabrics/0/rolls", {
            rolls: this.newRolls,
          });
          if (res) {
            hide_modal("#add-roll");
            this.newRolls = [];
            this.addNewRoll();
            toastr.success("Successfully Created");
            this.getRollLogs();
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    getCurrentSupplier(index) {
      let fabric_id = this.newRolls[index].fabric_id;
      let fabrics = this.allFabrics.filter((f) => {
        return f.id === fabric_id;
      });
      this.newRolls[index].supplier_id = fabrics[0].current_fabric_supplier_id;
    },

    async getFabrics() {
      let res = await axios.get("/v2/fabrics?as_dropdown=1");
      this.allFabrics = res.data.data.collection;
    },

    async getSuppliers() {
      try {
        let res = await axios.get(
          "/v2/fabrics/suppliers?as_dropdown=1&columns=id,name,code"
        );
        // Contactanate supplier names and codes to be used as full name
        this.suppliers = res.data.data.collection;
        this.suppliers.map((supplier) => {
          supplier["full_name"] = supplier.name + " - " + supplier.code;
        });
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async getRollLogs() {
      if (this.selectedFabricId) {
        try {
          let res = await axios.get(
            "/v2/fabrics/" + this.selectedFabricId + "/rolls"
          );
          this.originalLogs = res.data.data;
          this.applyShirtOrderNumberFilter();
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },
    /**
     * Filter the roll logs by the shirt oder number.
     * Since the logs are grouped by roll status, we will filter by group as well.
     */
    applyShirtOrderNumberFilter() {
      if (
        this.shirtOrderNumberFilter.length >= 0 &&
        this.shirtOrderNumberFilter !== ""
      ) {
        this.filteredLogs = {
          empty: this.filterRollLogGroup(this.originalLogs.empty),
          in_use: this.filterRollLogGroup(this.originalLogs.in_use),
          warehouse: this.filterRollLogGroup(this.originalLogs.warehouse),
        };
      } else {
        this.filteredLogs = this.originalLogs;
      }
    },
    /**
     * Filter one group of roll logs by the shirt oder number.
     *
     * @param rollGroup
     * @returns {*[]}
     */
    filterRollLogGroup(rollGroup) {
      const filterGroups = [];

      rollGroup.forEach((roll) => {
        /**
         * In order to keep the original roll list unchanged, we need to clone it
         * before filtering by the shirt oder number.
         * @type {*}
         */
        const filteredRoll = Object.assign({}, roll);
        filteredRoll.logs = roll.logs.filter((log) => {
          return (
            parseInt(log.shirt_order_id) ===
            parseInt(this.shirtOrderNumberFilter)
          );
        });

        if (filteredRoll.logs.length > 0) {
          filterGroups.push(filteredRoll);
        }
      });
      return filterGroups;
    },
    /**
     * Remove all filters from the roll log listing and reset the list.
     */
    clearRollLogFilters() {
      this.shirtOrderNumberFilter = "";
      this.selectedFabricId = null;
      this.originalLogs = { in_use: [], empty: [], warehouse: [] };
      this.filteredLogs = { in_use: [], empty: [], warehouse: [] };
    },
  },
};
</script>
